<div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
  <!-- Header Section -->
  <div class="text-center mb-5">
    <img src="assets/brand/{{
        layoutService.colorScheme() === 'light'
          ? 'logo-light'
          : 'logo-dark'
      }}.png" alt="Sequal App Logo" height="50" class="mb-3" />
    <div class="text-900 text-3xl font-medium mb-3">
      Email Verification
    </div>
  </div>

  <!-- Loading Spinner -->
  @if (isLoading()) {
    <div class="text-center">
      <p class="text-600 font-medium line-height-3 mb-4">Verifying your email, please wait...</p>
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)"
      animationDuration=".5s"></p-progressSpinner>
    </div>
  }

  <!-- Verification Result (Error) -->
  @if (!isLoading()) {
    <div class="text-center">
      <!-- Show error only if not loading and error exists -->
      @if (error()) {
        <div>
          <i class="pi pi-times-circle text-red-500 text-6xl mb-3"></i>
          <p class="text-900 text-xl font-medium mb-3">Verification Failed</p>
          <p class="text-600 font-medium line-height-3 mb-4">This link has expired or was already used. Ask an
          administrator to resend your sign-up link from Manage Users.</p>
          <button pButton pRipple label="Go to Login" icon="pi pi-sign-in" class="w-full"
          (click)="navigateToLogin()"></button>
        </div>
      }
      <!-- Handle case where there was no token initially -->
      @if (!token() && !error()) {
        <div>
          <i class="pi pi-exclamation-triangle text-yellow-500 text-6xl mb-3"></i>
          <p class="text-900 text-xl font-medium mb-3">Missing Token</p>
          <p class="text-600 font-medium line-height-3 mb-4">No verification token was found. Please use the link provided
          in your email.</p>
          <button pButton pRipple label="Go to Login" icon="pi pi-sign-in" class="w-full"
          (click)="navigateToLogin()"></button>
        </div>
      }
    </div>
  }
</div>